import React from "react";
import cns from "classnames";
import { TableCell, withStyles } from "@material-ui/core";
import ColumnSizer from "./ColumnSizer";
import { WithTooltip } from "@components";
import { Classes, ThemeType } from "@theme";
import { TableSearchColumn } from "./utils";

type Props = {
  classes: Classes<typeof styles>;
  columns: Array<TableSearchColumn<any>>;
  columnSizer: ColumnSizer;
  style?: React.CSSProperties;
};

const TableSearchHeader: React.FC<Props> = (props) => {
  const { classes, columnSizer } = props;

  return (
    <div
      className={classes.root}
      style={{ ...props.style, width: columnSizer.getTotalWidth() }}
    >
      {props.columns
        .filter((x) => !x.skip)
        .map((column) => {
          const width = props.columnSizer.getColumnWidth(column.dataKey);

          const className = cns(classes.headerCell, {
            [classes.cellVAlignCenter]: column.vAlign === "center"
          });

          return (
            <TableCell
              key={column.dataKey}
              component="div"
              className={className}
              variant="head"
              style={{ ...column.style, ...column.headerStyle, width }}
            >
              <WithTooltip placement={"top"} title={column.tooltip}>
                <div className={classes.headerCellInner}>{column.label}</div>
              </WithTooltip>
            </TableCell>
          );
        })}
    </div>
  );
};

const styles = (theme: ThemeType) => ({
  root: {
    display: "flex",
    alignItems: "flex-end"
  },

  headerCell: {
    display: "flex",
    fontFamily: theme.typography.fontFamily,
    overflowX: "hidden",
    padding: "0 !important"
  },

  headerCellInner: {
    padding: 8,
    width: "inherit"
  },

  cellVAlignCenter: {
    alignItems: "center"
  }
});

export default withStyles(styles as any)(TableSearchHeader);
